export default __webpack_public_path__ + "129a173c55b0d582ee867d0726bb54e2.png";